import React from "react";

function Services() {
  return (
    <article>
      <section className="features-4">
        <div className="features4-block py-5">
          <div className="container py-lg-4">
            <div className="title-content text-center mb-lg-5 mt-4">
              <h3 className="hny-title">CHÍNH SÁCH VÀ DỊCH VỤ</h3>
            </div>
            <div className="row features4-grids text-left mt-lg-4">
              <div className="col-lg-4 col-md-6 features4-grid mt-4">
                <div className="features4-grid-inn">
                  <div className="nuber-box">01</div>
                  <div className="features4-rightinfo">
                    <h5>
                      <a style={{ height: "50px" }}>
                        Dịch vụ chăm sóc làm đẹp xe
                      </a>
                    </h5>
                    <img
                      src="https://ssa-api.toyotavn.com.vn/Resources/Images/268FA41357992ACB639E7A9C3101BC1B.jpg"
                      style={{ width: "100%", height: "230px" }}
                      alt="/"
                    />
                    {/* <a href="#read" className="read">
                      Read more
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 features4-grid mt-4">
                <div className="features4-grid-inn">
                  <div className="nuber-box">02</div>
                  <div className="features4-rightinfo">
                    <h5>
                      <a style={{ height: "50px" }}>Chính sách bảo hành</a>
                    </h5>
                    <img
                      src="https://ssa-api.toyotavn.com.vn/Resources/Images/DE6B12D228FC7EC9F7F0E195F88427F5.png"
                      style={{ width: "100%", height: "230px" }}
                      alt="/"
                    />
                    {/* <a href="#read" className="read">
                      Read more
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 features4-grid mt-4">
                <div className="features4-grid-inn">
                  <div className="nuber-box">03</div>
                  <div className="features4-rightinfo">
                    <h5>
                      <a style={{ height: "50px" }}>Dịch vụ sửa chữa</a>
                    </h5>
                    <img
                      src="https://ssa-api.toyotavn.com.vn/Resources/Images/4837A1681127381F7C410E5AB2374CC7.jpg"
                      style={{ width: "100%", height: "230px" }}
                      alt="/"
                    />

                    {/* <a href="#read" className="read">
                      Read more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  );
}

export default Services;
